const subscriberConst = {
    liveMap: { noDataMin: '2880' },
    menuSettings: { type: 'ordinary' },  // ordinary | basic | driver | custom
  };

  export default subscriberConst;
  